import { Box } from "@dehub/theme";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

export function DashboardPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes("/") && !location.pathname.includes("/organization")) {
      navigate("/organization", { replace: true });
    }
  }, [location, navigate]);

  return <Box p="xl" />;
}
